(ns frontend.view.settings2.fundraising-pipelines.view
  (:require
   [common.entity :as entity]
   [common.localization :as loc]
   [common.util :as cu]
   [frontend.events :as-alias frontend-events]
   [frontend.page-components.default-page-layout :as default-page-layout]
   [frontend.page-components.zap-toolbar :as zap-toolbar]
   [frontend.routing :as routing]
   [frontend.state.current-session :as session]
   [frontend.view.entity :as f-entity]
   [frontend.view.modals.curtains.pipeline-settings-curtain.view :as pipeline-settings-curtain]
   [frontend.view.modals.events :as modals]
   [frontend.view.modals.pipeline-edit.view :as pipeline-edit]
   [frontend.view.settings2.creation-flow-toggle.view :as creation-flow-toggle]
   [frontend.view.settings2.fundraising-pipelines.db :as db]
   ;;[re-frame.core :as rf]
   [reagent.core :as r]
   [ui.components.breadcrumbs.view :as breadcrumbs]
   [ui.components.button.view :as button]))

(defn breadcrumbs
  []
  [breadcrumbs/container
   [breadcrumbs/item
    {:on-click (fn [_e]
                 (routing/set-view! [:account-settings :tab-key "config"]))}
    (loc/tr :settings/account-settings)]
   [breadcrumbs/item
    {:active? true}
    (loc/tr :settings/fundraising-pipelines)]])

(defn pipeline-row
  [all-fundraising-pipelines all-teams pipeline]
  (let [disabled? (:common/disabled? pipeline)
        inactive? (:pipeline/inactive? pipeline)
        pipeline-name (:pipeline/name pipeline)
        pipeline-fund (get @session/entities (:pipeline/fund pipeline))
        pipeline-teams (->> pipeline
                            :pipeline/teams
                            (map (fn [team-id]
                                   (get @session/entities team-id)))
                            (remove :common/disabled?))
        pipeline-stages (->> @session/all-opportunity-stages
                             (remove :common/disabled?)
                             (cu/filter-by :opportunity-stage/pipeline (:db/id pipeline))
                             (sort-by :common/ord))
        pipeline-id (:db/id pipeline)
        other-pipelines (->> all-fundraising-pipelines
                             (remove (fn [{:keys [db/id]}]
                                       (= pipeline-id id))))]
    [:tr
     {:class-name "*:whitespace-nowrap *:px-2 *:py-3 *:text-sm *:text-base-light-text even:bg-base-regular"
      :key        (str "pipeline-row-" pipeline-name)}
     [:td
      (cond disabled?
            (loc/tr :disabled)
            inactive?
            (loc/tr :archived)
            :else
            (loc/tr :active))]
     [:td
      [:div
       {:class "flex items-center gap-2"}
       pipeline-name]]
     [:td
      [:ul
       (->> pipeline-teams
            (map (fn [team]
                   [:li
                    {:key (str "pipeline-team-" pipeline-name "-" (:db/id team))}
                    (entity/display-string team)]))
            (doall))]]
     [:td
      [:div
       {:class "flex"}
       [:ul
        {:class "flex flex-wrap gap-1"}
        (->> pipeline-stages
             (map (fn [stage]
                    [:li
                     {:key   (str "pipeline-stage-" pipeline-name "-" (:db/id stage))
                      :class "py-1 px-2 bg-complement-regular rounded-full"}
                     (entity/display-string stage)]))
             (doall))]
       (when-not disabled?
         [button/square-secondary-open
          {:dom-id (str "froppo-pipeline-stage-edit-button-" pipeline-name)
           :tooltip  (loc/tr :tooltip/configure-pipeline-stages)
           :class    "pt-1"
           :on-click (fn [_]
                       (modals/open-modal!
                        pipeline-settings-curtain/modal-key
                        {:pipeline-id          (:db/id pipeline)
                         :stage-entity-type    :entity.type/opportunity-stage
                         :stage-name-attribute :opportunity-stage/name
                         :pipeline-attribute   :opportunity-stage/pipeline}))}
          [:i.fas.fa-pen]])]]
     (when (session/has-feature-access? :feature/fund-management)
       [:td
        (str (entity/display-string pipeline-fund))])
     [:td
      (when-not disabled?
        [button/square-secondary-open
         {:tooltip  (loc/tr :show-permissions)
          :on-click (fn [_]
                      (routing/set-view! [:settings.permissions/pipeline :id
                                          (:db/id pipeline)]))}
         [:i.fas.fa-user-lock]])]
     [:td
      (when-not disabled?
        [button/square-secondary-open
         {:tooltip  (loc/tr :edit)
          :on-click (fn [_]
                      (modals/open-modal! pipeline-edit/modal-key
                                          {:pipeline-id    (:db/id pipeline)
                                           :existing-teams all-teams
                                           :existing-pipelines other-pipelines}))}
         [:i.fas.fa-ellipsis-v]])]]))

(defn component
  []
  (r/create-class
   {:reagent-render
    (fn []
      (let [all-teams (->> @session/all-teams
                           (remove :common/disabled?))
            all-fundraising-pipelines (->> @session/all-froppo-pipelines
                                           (remove :common/disabled?))]
        [:<>
         [zap-toolbar/view db/state breadcrumbs nil nil]
         [:div
          {:class "bg-base-light text-base-light-text h-[calc(100vh_-_52px-_37px)] overflow-auto"}
          [:div
           {:class "flex md:inline-flex px-4 py-4"}
           (if (empty? all-fundraising-pipelines)
             [:div
              {:class "w-screen flex flex-col gap-6 justify-center items-center"}
              [:img
               {:src        "/img/no-data-created.svg"
                :class-name "max-w-32 mx-auto"}]
              [button/primary-solid {:on-click (fn [_e]
                                                 (f-entity/open-creator! :entity.type/pipeline
                                                                         {:start-value {:pipeline/entity-type
                                                                                        :entity.type/fundraising-opportunity}
                                                                          :on-ok!     (fn [{:keys [close-cb!]}]
                                                                                        (close-cb!))}))}
               [:span [:i {:class "fal fa-plus"}]] (loc/tr :create)]]
             [:div
              {:class "max-w-full md:p-3 flex flex-col gap-4"}

              (when (session/froppo-creation-flow-feature?)
                [:div
                 {:class "flex flex-row gap-4"}
                 [creation-flow-toggle/view
                  {:preference-key    :froppo-creation-flow
                   :title-loc-key     :new-fundraising-opportunity-creation-flow
                   :for-me-loc-key    :creation-flow-toggle-for-me
                   :for-all-loc-key   :creation-flow-toggle-for-all
                   :info-loc-key      :creation-flow-toggle-info
                   :info-icon-tooltip (loc/tr :froppo-creation-flow-toggle-info-icon
                                              [(loc/tr :creator-config-item-label)])}]

                 (when (and (session/entry-criteria-feature?)
                            (session/froppo-creation-flow?))
                   [creation-flow-toggle/view
                    {:info-icon-tooltip (loc/tr :stage-entry-criteria-info)
                     :preference-key :stage-entry-criteria-froppo
                     :title-loc-key :stage-entry-criteria-for-fundraising-opportunities
                     :for-me-loc-key :toggle-for-me
                     :for-all-loc-key :toggle-for-all}])])

              [:div {:class "flex justify-between items-center"}
               [:span
                {:class "text-xl font-semibold"}
                (loc/tr :settings.pipelines/pipelines-heading)]

               [button/sm-primary-solid {:on-click (fn [_e]
                                                     (f-entity/open-creator! :entity.type/pipeline
                                                                             {:start-value {:pipeline/entity-type
                                                                                            :entity.type/fundraising-opportunity}
                                                                              :on-ok!     (fn [{:keys [close-cb!]}]
                                                                                            (close-cb!))}))}
                [:span [:i {:class "fal fa-plus"}]] (loc/tr :settings/create-fundraising-pipelines)]]
              [:div
               {:class "max-w-full overflow-auto border border-solid border-base-light-border-paler rounded-lg overflow-x-auto"}
               [:table
                {:class "w-full md:w-auto divide-y divide-solid divide-base-light-border-paler"}
                [:thead
                 [:tr
                  {:class "*:whitespace-nowrap *:px-2 *:py-3 *:text-sm *:text-base-light-text"}
                  [:th (loc/tr :settings.pipelines/table-heading-status)]
                  [:th (loc/tr :settings.pipelines/table-heading-name)]
                  [:th (loc/tr :settings.pipelines/table-heading-teams)]
                  [:th (loc/tr :settings.pipelines/table-heading-stages)]
                  (when (session/has-feature-access? :feature/fund-management)
                    [:th (loc/tr :settings.pipelines/table-heading-fund)])
                  [:th (loc/tr :settings.pipelines/table-heading-permissions)]
                  [:th (loc/tr :settings.pipelines/table-heading-edit)]]]
                [:tbody
                 {:class "divide-y divide-solid divide-base-light-border-paler"}
                 (->> all-fundraising-pipelines
                      (sort-by :pipeline/name)
                      (map (partial pipeline-row all-fundraising-pipelines all-teams))
                      (doall))]]]])]]]))}))

(defmethod routing/render-view :settings/fundraising-pipelines
  [_]
  [default-page-layout/view
   {:class-name ""}
   [component]])
